"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _navigationContext = require("../../contextProviders/navigationContext");
var _storageKeys = require("../../constants/app/storageKeys");
require("./error.scss");
var _slice = require("../../store/quote/slice");
var _slice2 = require("../../store/app/slice");
var _steps = require("../../constants/app/steps");
var _brandContext = require("../../contextProviders/brandContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Error = exports.Error = function Error(_ref) {
  var _location$state, _location$state2, _location$state3, _location$state4;
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Invalid Quote Data' : _ref$title,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'Quote is not valid, please try a new quote' : _ref$message;
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    StepDefinitions = _useContext.activeBrandContext.steps.StepDefinitions;
  var dispatch = (0, _reactRedux.useDispatch)();
  var location = (0, _reactRouterDom.useLocation)();
  var _useContext2 = (0, _react.useContext)(_navigationContext.NavigationContext),
    navigationController = _useContext2.navigationController;
  var _ref2 = (location === null || location === void 0 ? void 0 : location.state) || {},
    buttonText = _ref2.buttonText,
    customPath = _ref2.customPath;
  var handleButtonClick = function handleButtonClick() {
    if (!customPath) {
      sessionStorage.removeItem(_storageKeys.QUOTE_REFERENCE);
      dispatch((0, _slice.resetQuote)());
      dispatch((0, _slice2.resetSession)());
    }
    navigationController(customPath !== null && customPath !== void 0 ? customPath : "/".concat(StepDefinitions.find(function (step) {
      return step.id === _steps.StepIndex.youAndYourPets;
    }).url));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "errorContainer"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "errorTitle"
  }, (_location$state = location.state) !== null && _location$state !== void 0 && _location$state.title ? (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.title : title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "errorMessage"
  }, " ", (_location$state3 = location.state) !== null && _location$state3 !== void 0 && _location$state3.message ? (_location$state4 = location.state) === null || _location$state4 === void 0 ? void 0 : _location$state4.message : message, " "), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "button primary outline",
    onClick: handleButtonClick
  }, buttonText !== null && buttonText !== void 0 ? buttonText : 'New Quote'));
};
Error.propTypes = {
  title: _propTypes["default"].string,
  message: _propTypes["default"].string
};